import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export const APP_SCHEME = 'legacyforge';

export const isNativeApp = () => Capacitor.isNativePlatform();

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export async function startGoogleAuth() {
  if (isNativeApp()) {
    // Google blocks sign-in inside app webviews, so use the phone's browser and return via /app-return
    const redirectUrl = window.location.origin + '/app-return';
    await Browser.open({ url: `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}` });
    return;
  }
  const redirectUrl = window.location.origin + '/dashboard';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
